import { getPerspectiveId } from "@app/lib/perspective";
import WalletPage, { walletQuery } from "@app/pages/wallet/wallet-page";
import type { walletPage_Query } from "@app/queries/walletPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

// One dynamic route serves every wallet (deel, wise, ...). Date-lens exempt: a
// wallet has its own timeline, so the loader takes no `from` and the global date
// switcher does not refetch it.
export const Route = createFileRoute("/_authed/wallet/$slug")({
  loader: ({ params }) =>
    loadQuery<walletPage_Query>(
      environment,
      walletQuery,
      {
        slug: params.slug,
        perspectiveId: getPerspectiveId() ?? undefined,
      },
      { fetchPolicy: "store-or-network" }
    ),
  head: ({ params }) =>
    pageHead(
      `${params.slug.charAt(0).toUpperCase()}${params.slug.slice(1)} wallet`
    ),
  component: WalletRoute,
});

function WalletRoute() {
  const queryRef = Route.useLoaderData();
  const { slug } = Route.useParams();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading wallet</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading {slug} wallet…</div>}
      >
        <WalletPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
